import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pyramid-desc',
  templateUrl: './pyramid-desc.component.html',
  styleUrls: ['./pyramid-desc.component.less']
})
export class PyramidDescComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/pyramid-desc/pyramid-desc.component.ts